import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  accountsListHasPendingScrollRestore,
  isAccountsListPath,
} from '../lib/accountsListState';

/** Reset the app shell scroller on route changes (window is often not the scroll root). */
export function ScrollToTopOnNavigate() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    if (isAccountsListPath(pathname) && accountsListHasPendingScrollRestore()) return;

    const scrollers = [
      document.querySelector('.app-shell--dock .main'),
      document.querySelector('.page'),
      document.scrollingElement,
    ].filter((el): el is Element => el instanceof Element);

    for (const el of scrollers) {
      el.scrollTop = 0;
      el.scrollLeft = 0;
    }
    window.scrollTo(0, 0);
  }, [pathname, search, hash]);

  return null;
}
